import Listing from "./scripts/components/Listing";
import { format } from "date-fns";
import flatpickr from "flatpickr";

class NewsListing {
    constructor(element) {
        this.el = element;
        this.form = document.getElementById("news-filters-form");
        this.intervals = document.querySelectorAll('[name="interval"]');
        this.labelFieldRadios =
            this.form.querySelectorAll(`.label-field--radio`);

        this.init();
    }

    init() {
        if (this.el) {
            this.listing = new Listing({
                root: this.el,
                form: this.form,
                listingId: "news",
                promoInterval: 4,
                pagination: {
                    el: ".pagination",
                    perPage: 18,
                },
                html: "/wp-content/uploads/news.html",
                json: "/wp-content/uploads/news.json",
                objectName: {
                    singular: "article",
                    plural: "articles",
                },
                callback: () => {
                    // console.log(this.listing.state.filtersStatus);
                },
            });
        }
    }

    // handleDateChange(selectedDates, dateStr, instance) {
    //     if (!selectedDates.length) {
    //         this.picker.classList.remove("has-value");
    //     } else {
    //         this.picker.classList.add("has-value");
    //     }

    //     instance.element.value = dateStr.replace(" to ", "/");

    //     if (this.picker?.value) {
    //         this.intervals.forEach((item) => {
    //             item.checked = false;
    //         });
    //     }
    // }
}

document.addEventListener("DOMContentLoaded", () => {
    const element = document.getElementById("news-listing");

    if (element) {
        new NewsListing(element);
    }
});
